import React from "react";
import { constants } from "../../../../../../../../../utils/Constants";
import ProcessComponent from "../../../../../../../../core/ProcessComponent";
import ComponentHeader from "../../../../../../../../core/ComponentHeader/ComponentHeader";
import { labels } from "../../../../../../../../../localization/labels";
import { Row, Col, FormLabel, FormGroup } from "react-bootstrap";
import SubmitControl from "../../../../../../../../core/SubmitControl";
import { Affix } from "antd";
import SubmitButton from "../../../../../../../../core/SubmitButton";
import DropDown from "../../../../../../../../core/DropDown";
import ClassificationSelection from "../../../../../../../page/ClassificationSelection";

const InvolvementRole = props => {
  return (
    <ProcessComponent processes={[constants.OPERATION_SECURITY_ADMINISTRATION]}>
      <div className="container">
        <ComponentHeader
          title={labels.involvementRole}
          id={props.involvementRole.id}
          showBackButton
        />
        <div className="bordered_bottom_rounded">
          <br></br>
          <Row>
            <Col sm="2">
              <FormLabel className="Label">
                {labels.involvementRoleType}
              </FormLabel>
            </Col>
            <Col sm="10">
              <FormGroup controlId="involvementRoleType">
                <DropDown
                  value={props.involvementRole.involvementRoleType}
                  options={props.possibleInvolvementRoleTypes.map(x => ({
                    value: x,
                    label: x.name
                  }))}
                  onChange={props.onChange}
                  targetId={"involvementRoleType"}
                  placeholder={labels.involvementRoleType}
                  required={
                    props.validationRules.involvementRoleType &&
                    props.validationRules.involvementRoleType.required
                  }
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel className="Label">{labels.dateFromTo}</FormLabel>
            </Col>
            <Col sm="5">
              <FormGroup controlId="dateFromTo">
                <SubmitControl
                  type="dateRange"
                  placeholder={[
                    labels.dateFromPlaceholder,
                    labels.dateToPlaceholder
                  ]}
                  value={props.involvementRole.dateFromTo}
                  onChange={props.onChange}
                  controlId={"dateFromTo"}
                  validationRule={
                    props.validationRules && props.validationRules.dateFromTo
                  }
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <ClassificationSelection
                entity={props.involvementRole}
                messageHandler={props.messageHandler}
                breadcrumbsHandler={props.breadcrumbsHandler}
                setInitialEntityPropertyState={
                  props.setInitialEntityPropertyState
                }
                setClassificationsOnEntity={props.setClassificationsOnEntity}
                readOnly={!props.editable}
                initialPageSize={props.initialPageSize}
              />
            </Col>
          </Row>
        </div>
        <Affix offsetBottom={true}>
          <div className="bottom_bar">
            <SubmitButton
              type="save"
              onClick={props.onSave}
              disabled={props.disabled}
              partyId={props.partyId}
            />
          </div>
        </Affix>
      </div>
    </ProcessComponent>
  );
};

export default InvolvementRole;
